import { SizeUnit } from '@features/file-explorer/components/Toolbar/filterTypes'

export const SIZE_MULTIPLIERS: Record<SizeUnit, number> = {
  'B': 1,
  'KB': 1024,
  'MB': 1024 * 1024,
  'GB': 1024 * 1024 * 1024,
  'TB': 1024 * 1024 * 1024 * 1024
}

export function convertSizeToBytes(value: string, unit: SizeUnit): string {
  const numValue = parseFloat(value)
  return Math.floor(numValue * SIZE_MULTIPLIERS[unit]).toString()
}
